import { render } from "./AppBreadcrumbs.vue?vue&type=template&id=b80b396a&scoped=true"
import script from "./AppBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./AppBreadcrumbs.vue?vue&type=script&lang=js"

import "./AppBreadcrumbs.vue?vue&type=style&index=0&id=b80b396a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b80b396a"]])

export default __exports__